// import { fontColorList } from 'admin/component/UserInfoChange'
import { textcolor1 } from 'admin/component/UserInfoChange'
import { CPS_CLIENT } from 'client'
import React, { useState, useEffect } from 'react'
import { getUserSettingFromCookie } from './../UserCookieSetting'
const ClientContext = React.createContext(null)

// default value also need to set in reducer
const ClientContextProvider = ({ children, userName, CLIENT }) => {
  const { darkMode = false, zoom = 100, fontColor } = getUserSettingFromCookie(
    userName
  )
  // console.log(userCookies)

  const [theme, setTheme] = useState(darkMode)
  const [pageZoom, setPageZoom] = useState(zoom)
  const [fontColorstate, setFontColor] = useState(fontColor)
  useEffect(
    _ => {
      if (userName) setTheme(darkMode)
    },
    [darkMode, userName]
  )
  useEffect(
    _ => {
      if (userName) {
        setPageZoom(zoom)
        document.body.style.zoom = zoom + '%'
      }
    },
    [zoom, userName]
  )
  useEffect(
    _ => {
      if (userName && fontColor) {
        setFontColor(fontColor)
        // document.body.classList.remove(...fontColorList)
        document.body.classList.add(fontColor)
      }
    },
    [fontColor, userName, fontColorstate]
  )

  useEffect(
    _ => {
      if (fontColor === undefined && CLIENT === CPS_CLIENT)
        document.body.classList.add(textcolor1)
    },
    [CLIENT, fontColor]
  )

  useEffect(
    _ => {
      document.body.style = theme
        ? 'filter: invert(90%) hue-rotate(180deg);'
        : ''
    },
    [theme]
  )

  return (
    <ClientContext.Provider
      value={{
        theme,
        setTheme,
        pageZoom,
        setPageZoom,
        fontColor: fontColorstate,
        setFontColor,
      }}
    >
      {children}
    </ClientContext.Provider>
  )
}

export { ClientContext }
export default ClientContextProvider
